import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Collapse from 'react-bootstrap/Collapse';
import TaskEditor from '~/components/forms/HtmlEditors/TaskEditor';
import { TeammatePicker } from '~/components/forms/dropdowns/TeamMemberSelect';
import Buttons from './AgentAlertModal/Buttons';
import Select from '~/components/forms/dropdowns/SelectWrapper/Select';
import AsyncSelect from '~/components/forms/dropdowns/SelectWrapper/AsyncSelect';
import { TASK_CATEGORY_OPTIONS } from '~/constants/dropdowns/TaskCategoryOptions';
import { TASK_PRIORITY_OPTIONS } from '~/constants/dropdowns/TaskPriorityOptions';
import { TASK_STATUS_OPTIONS } from '~/constants/dropdowns/TaskStatusOptions';

const AgentAlertTask = ({
  isOpen,
  task,
  isSaving,
  errors,
  handleFieldChange,
  handleCloseModal,
  handleConfirm,
}) => (
  <Collapse in={isOpen} mountOnEnter unmountOnExit>
    <div className="row mt-3">
      <div className="col p0">
        <div className="form-row">
          <div className="form-group col-md-6">
            <label htmlFor="agent-alert-task-name">Task Name</label>
            <input
              id="agent-alert-task-name"
              name="name"
              value={task.name}
              className={classNames('d-block form-control', errors.name ? 'has-error' : '')}
              placeholder="Enter Name"
              onChange={(e) => handleFieldChange('name')(e.target.value)}
            />
          </div>

          <div className="form-group col-md-6">
            <label htmlFor="agent-alert-task-category">Task Category</label>
            <Select
              id="agent-alert-task-category"
              name="category"
              options={TASK_CATEGORY_OPTIONS}
              placeholder="Select Category"
              value={task.category}
              isInvalid={!!errors.category}
              onChange={(val) => handleFieldChange('category')(val?.value || '')}
              isSearchable
            />
          </div>
        </div>

        <div className="form-group mb15">
          <label htmlFor="agent-alert-task-description" className="d-block">
            Description
          </label>

          <TaskEditor
            className={errors.description ? 'tiny-mce has-error' : ''}
            onChange={(html) => handleFieldChange('description')(html)}
            placeholder="Enter Description"
            id="agent-alert-task-description"
            spellCheck={isOpen}
          />
        </div>

        <div className="form-row">
          <div className="form-group col-md-12">
            <label htmlFor="agent-alert-task-lead-ids" className="d-block">
              Related Contacts
            </label>

            <AsyncSelect
              id="agent-alert-task-lead-ids"
              placeholder="Please Select Contacts ..."
              resourcePath="leads"
              formatOption={(lead) => ({
                value: lead.id,
                label: lead.name,
              })}
              isMulti
              isSearchable
              isInvalid={!!errors.lead_ids}
              value={task.lead_ids}
              onChange={(values) => handleFieldChange('lead_ids')(values ? values.map((item) => item.value) : [])}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label
              htmlFor="agent-alert-task-owner-id"
              className="form-control-label"
            >
              Owner
            </label>

            <TeammatePicker
              id="agent-alert-task-owner-id"
              name="owner_id"
              placeholder="Owner"
              value={task.owner_id}
              onChange={(opt) => handleFieldChange('owner_id')(opt && opt.value)}
              isClearable
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="agent-alert-task-priority">Priority</label>
            <Select
              id="agent-alert-task-priority"
              name="priority"
              placeholder="Select Priority"
              value={task.priority}
              options={TASK_PRIORITY_OPTIONS}
              isSearchable
              isInvalid={!!errors.priority}
              onChange={(val) => handleFieldChange('priority')(val?.value || '')}
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="agent-alert-task-status">Status</label>
            <Select
              id="agent-alert-task-status"
              name="status"
              placeholder="Select Status"
              value={task.status}
              options={TASK_STATUS_OPTIONS}
              isSearchable
              isInvalid={!!errors.status}
              onChange={(val) => handleFieldChange('status')(val?.value || '')}
            />
          </div>
        </div>

        {isOpen && (
          <Buttons
            handleCloseModal={handleCloseModal}
            handleConfirm={handleConfirm}
            isSaving={isSaving}
          />
        )}
      </div>
    </div>
  </Collapse>
);

AgentAlertTask.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  task:   PropTypes.shape({
    name:        PropTypes.string,
    category:    PropTypes.string,
    due_date_at: PropTypes.instanceOf(Date),
    description: PropTypes.string,
    owner_id:    PropTypes.number,
    priority:    PropTypes.string,
    status:      PropTypes.string,
    lead_ids:    PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
  isSaving:          PropTypes.bool.isRequired,
  errors:            PropTypes.shape({}).isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  handleCloseModal:  PropTypes.func.isRequired,
  handleConfirm:     PropTypes.func.isRequired,
};

export default AgentAlertTask;
